<script lang="ts" setup>
import { ru } from '@nuxt/ui/locale'

// Vite `?url` must stay in this SFC — Nitro cannot resolve it from shared `.ts` (see brand/assets.ts).
import fontRegularUrl from '~/app/assets/brand/fonts/IbmPlexMono/IBMPlexMono-Regular.ttf?url'

useHead({
  link: [
    {
      rel: 'preconnect',
      href: 'https://storage.yandexcloud.net',
    },
    {
      rel: 'preload',
      as: 'font',
      fetchpriority: 'high',
      type: 'font/ttf',
      href: fontRegularUrl,
      crossorigin: 'anonymous',
    },
  ],
})

const {
  status,
  ensureStarted,
} = usePlatformSessionGate()

await ensureStarted()
</script>

<template>
  <UApp :locale="ru" :toaster="{ position: 'top-right' }">
    <PlatformGate v-if="status === 'blocked'" />
    <PlatformAccountChoice v-else-if="status === 'account-choice'" />
    <MiniAppShell v-else-if="status === 'ready'">
      <NuxtPage />
    </MiniAppShell>
    <div
      v-else
      class="fixed inset-0 z-50 flex items-center justify-center bg-default p-6 pt-[max(1.5rem,env(safe-area-inset-top))] pb-[max(1.5rem,env(safe-area-inset-bottom))] pl-[max(1.5rem,env(safe-area-inset-left))] pr-[max(1.5rem,env(safe-area-inset-right))]"
      data-testid="platform-gate-pending"
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <UEmpty
        variant="naked"
        size="lg"
        description="Подключаем запуск Mini App…"
      >
        <template #header>
          <div class="flex flex-col items-center gap-2 max-w-sm text-center">
            <UIcon
              name="i-lucide-loader-circle"
              class="size-11 shrink-0 mb-2 animate-spin text-[22px]"
            />
            <h1 class="text-highlighted text-pretty font-medium text-base">
              Загрузка
            </h1>
          </div>
        </template>
      </UEmpty>
    </div>
  </UApp>
</template>
